/* this file added by Bearer Web Developer  */
import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import styles from './sortMenu.module.scss';
import { useAppState } from "../../../../states/app-state";
import { TSortBasis } from "../../../../states/reservedOrdersState/models/sortBasis";
import { useThemeMode } from "../../../../states/contexts/theme";


const SortMenu: React.FC = () => {
    const appState = useAppState();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const handleClose = () => {
        setAnchorEl(null);
    };
    const sortBy = (sortBasis: TSortBasis) => {
        appState?.ReservedOrders?.sortReservedOrdersList(sortBasis);
        appState?.ReservedOrders?.setSortBasis(sortBasis);
        handleClose();
    };
    return (
        <div className={styles.sort_menu} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Button className={styles.filter} disableRipple={true} onClick={handleClick}>
                {
                    theme === 'dark' ? <img src="/filter-white.svg" alt="" width={24} height={24} /> :
                        <img src="/filter-black.webp" alt="" width={24} height={24} />
                }
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => { sortBy('Order Due') }}>Order Due</MenuItem>
                <MenuItem onClick={() => { sortBy('expiry_time') }}>Expiry Time</MenuItem>
                <MenuItem onClick={() => { sortBy('creation_time') }}>Creation Time</MenuItem>
            </Menu>
        </div>
    )
}
export default SortMenu;

